(() => {
  const choices = {
    other: { label: 'Something else', hint: 'Ask us a question or share a request', path: '<path d="M5 4h14v12H9l-4 4V4Z"/><path d="M8 8h8M8 12h5"/>' },
    advice: { label: 'Choosing or customising a rug', hint: 'Sizing, colour and custom options', path: '<path d="M4 7h16v10H4zM8 7v4m4-4v3m4-3v4"/>' },
    callback: { label: 'Request a phone call', hint: 'Leave a number for us to contact you', path: '<path d="m7 3 3 5-3 2c2 3 4 5 7 7l2-3 5 3-2 4C10 22 2 14 3 5l4-2Z"/>' },
    order: { label: 'An existing order', hint: 'Delivery, changes, returns or a concern', path: '<path d="m3 7 9-4 9 4v11l-9 4-9-4V7Zm0 0 9 4 9-4M12 11v11M7 5l10 4"/>' },
    sample: { label: 'Requesting samples', hint: 'Tell us which rugs or colours you are considering', path: '<path d="M4 4h10v10H4zM10 14v6h10V10h-6"/>' },
    trade: { label: 'A professional project', hint: 'For designers, architects and studios', path: '<path d="M3 7h18v14H3zM8 7V3h8v4M3 12h18M10 12v3h4v-3"/>' },
    terms: { label: 'Purchase terms', hint: 'A question about the terms for your order', path: '<path d="M6 3h9l4 4v14H6zM14 3v5h5M9 12h7M9 16h7"/>' }
  };
  function icon(path) {
    const node = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    node.setAttribute('viewBox', '0 0 24 24');
    node.setAttribute('fill', 'none');
    node.setAttribute('stroke', 'currentColor');
    node.setAttribute('stroke-width', '1.35');
    node.setAttribute('stroke-linecap', 'round');
    node.setAttribute('stroke-linejoin', 'round');
    node.setAttribute('aria-hidden', 'true');
    node.setAttribute('focusable', 'false');
    node.classList.add('vr-purpose-icon');
    node.innerHTML = path;
    return node;
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-vorug-contact-help]').forEach(help => {
      if (help.dataset.helpReady) return;
      help.dataset.helpReady = 'true';
      const topics = help.querySelector('.vr-help-topics');
      const disclosures = [...topics.querySelectorAll('.vr-help-topic')];
      const panel = topics.querySelector('.vr-help-panel');
      const heading = document.createElement('h3');
      const desktop = matchMedia('(min-width: 1000px)');
      const answers = disclosures.map((topic, index) => {
        const summary = topic.querySelector('summary');
        const answer = topic.querySelector('.vr-help-answer');
        summary.id = `${help.getAttribute('aria-labelledby')}-topic-${index}`;
        answer.id = `${summary.id}-answer`;
        summary.setAttribute('aria-controls', answer.id);
        summary.addEventListener('click', event => {
          if (desktop.matches && topic.open) event.preventDefault();
        });
        return { topic, summary, answer };
      });
      panel.append(heading);
      panel.setAttribute('role', 'region');
      topics.dataset.helpLayout = 'true';
      function renderTopic() {
        let selected = answers.find(item => item.topic.open);
        if (desktop.matches && !selected) {
          selected = answers[0];
          selected.topic.open = true;
        }
        const focused = document.activeElement;
        answers.forEach(item => {
          const parent = desktop.matches && item === selected ? panel : item.topic;
          if (item.answer.parentElement !== parent) parent.append(item.answer);
        });
        panel.hidden = !desktop.matches || !selected;
        if (selected) {
          heading.textContent = selected.summary.querySelector('span').textContent;
          panel.setAttribute('aria-labelledby', selected.summary.id);
        }
        if (focused?.isConnected && document.activeElement !== focused) focused.focus({ preventScroll: true });
      }
      disclosures.forEach(topic => topic.addEventListener('toggle', () => {
        if (topic.open) disclosures.forEach(other => { if (other !== topic) other.open = false; });
        renderTopic();
      }));
      desktop.addEventListener('change', renderTopic);
      const unloadHelp = event => {
        if (!event.target.contains(help)) return;
        desktop.removeEventListener('change', renderTopic);
        document.removeEventListener('shopify:section:unload', unloadHelp);
      };
      document.addEventListener('shopify:section:unload', unloadHelp);
      renderTopic();

      const search = help.querySelector('[data-help-search]');
      const query = help.querySelector('[data-help-query]');
      const clear = help.querySelector('[data-help-clear]');
      const results = help.querySelector('[data-help-results]');
      const status = help.querySelector('[data-help-status]');
      const empty = help.querySelector('[data-help-empty]');
      const pages = [...help.querySelectorAll('[data-help-page]')];
      const normalize = text => text.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      function filter() {
        const words = normalize(query.value.trim()).split(/\s+/).filter(Boolean);
        let count = 0;
        pages.forEach(page => {
          const text = normalize(page.textContent + ' ' + page.dataset.helpKeywords);
          page.hidden = !words.every(word => text.includes(word));
          if (!page.hidden) count++;
        });
        results.hidden = !words.length;
        clear.hidden = !words.length;
        status.textContent = words.length ? (count ? `${count} useful ${count === 1 ? 'page' : 'pages'}` : 'No matching guide yet.') : '';
        empty.hidden = count > 0;
      }
      search.hidden = false;
      query.addEventListener('input', filter);
      clear.addEventListener('click', () => { query.value = ''; filter(); query.focus(); });
      query.addEventListener('keydown', event => {
        if (event.key === 'Escape') { query.value = ''; filter(); }
      });
      filter();

      const select = help.closest('[data-vorug-service="contact"]')?.querySelector('[data-enquiry-purpose]');
      if (!select) return;
      [...select.options].forEach(option => {
        if (choices[option.dataset.intent]) option.textContent = choices[option.dataset.intent].label;
      });
      function connectPurpose() {
      const root = select.parentElement.querySelector('.vr-select');
      if (!root) return false;
      if (root.classList.contains('vr-purpose-selector')) return true;
      root.classList.add('vr-purpose-selector');
      const trigger = root.querySelector('.vr-select-trigger');
      const list = root.querySelector('.vr-select-list');
      function decorate() {
        const options = [...select.options].filter(option => (!option.hidden || option.selected) && !option.disabled);
        [...list.children].forEach((row, index) => {
          if (row.dataset.purposeDecorated) return;
          const choice = choices[options[index]?.dataset.intent];
          if (!choice) return;
          const copy = document.createElement('span');
          copy.className = 'vr-purpose-copy';
          const title = document.createElement('span'); title.textContent = choice.label;
          const hint = document.createElement('small'); hint.textContent = choice.hint;
          copy.append(title, hint);
          row.replaceChildren(icon(choice.path), copy);
          row.dataset.purposeDecorated = 'true';
        });
        const selected = choices[select.selectedOptions[0]?.dataset.intent];
        if (selected) {
          trigger.querySelector('.vr-purpose-icon')?.remove();
          trigger.prepend(icon(selected.path));
          root.querySelector('.vr-select-value').textContent = selected.label;
        }
      }
      const observer = new MutationObserver(decorate);
      observer.observe(list, { childList: true });
      select.addEventListener('change', decorate);
      const unload = event => {
        if (event.target.contains(help)) {
          observer.disconnect();
          document.removeEventListener('shopify:section:unload', unload);
        }
      };
      document.addEventListener('shopify:section:unload', unload);
      decorate();
      return true;
      }
      if (!connectPurpose()) {
        const ready = new MutationObserver(() => { if (connectPurpose()) ready.disconnect(); });
        ready.observe(select.parentElement, { childList: true });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
